"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.productCompare.name': 'Porównywanie Produktów',
    'tools.productCompare.description': 'Porównuj produkty z określonych domen e-commerce i stron internetowych',
};
